import { FormikValues } from 'formik';
import BusinessTripHistoryTable from './BusinessTripHistoryTable/BusinessTripHistoryTable';
import { getAccommodations } from '~/utils/api/queries';
import { useEffect, useState } from 'react';
import { AccommodationItem } from '../AccommodationForm';

interface Props {
  formik: FormikValues;
  isEditing: boolean | undefined;
  accommodation: {
    id: number;
    name: string;
    companies_id: number;
    section: string;
  };
}

export interface IRoom {
  id: number;
  name: string;
}

export const BusinessTripForm = ({ formik, isEditing }: Props) => {
  const [accommodations, setAccommodations] = useState<AccommodationItem[]>([]);
  const [sort, setSort] = useState({
    field: '',
    direction: '',
  });

  const loadAccomodations = async () => {
    const { data } = await getAccommodations({
      sort: sort.direction,
      perPage: 100,
      field: sort.field,
    });
    setAccommodations(data);
  };

  useEffect(() => {
    loadAccomodations();
  }, []);

  return (
    <BusinessTripHistoryTable
      isEditing={isEditing}
      sort={sort}
      setSort={setSort}
      accommodations={accommodations}
      history={formik.values.business_trips}
      formik={formik}
    />
  );
};
